import InternalAuditScopeDTO, {
  InternalAuditScopeCandidateDTO,
  InternalAuditScopeIndexDTO,
  InternalAuditScopeItemDTO,
  InternalAuditScopeSuggestionDTO,
} from 'models/dto/internalAuditScopeDTO';
import Entity, { EntityTypes } from 'models/entity';
import {
  InternalAuditScope,
  InternalAuditScopeCandidate,
  InternalAuditScopeIndex,
  InternalAuditScopeItem,
  InternalAuditScopeRelation,
  InternalAuditScopeSuggestion,
} from 'models/internalAuditScope';
import { fromApiDateTimeOptional } from 'utils/datetime';

export function mapFromInternalAuditScopeSuggestions(
  dtos: InternalAuditScopeSuggestionDTO[] | undefined,
): InternalAuditScopeSuggestion[] {
  return (dtos ?? []).map((dto) => {
    const suggestion = new InternalAuditScopeSuggestion();
    suggestion.entity = new Entity(dto.entityId, dto.entityType as EntityTypes, dto.name ?? '', dto.code);
    suggestion.reason = dto.reason;

    return suggestion;
  });
}

export function mapFromInternalAuditScopeItems(dtos: InternalAuditScopeItemDTO[] | undefined): Entity[] {
  return (dtos ?? []).map(
    (item) => new Entity(item.entityId, item.entityType as EntityTypes, item.name ?? '', item.code),
  );
}

export function mapFromInternalAuditScopeIndex(
  dtos: InternalAuditScopeIndexDTO[] | undefined,
): InternalAuditScopeIndex[] {
  return (dtos ?? []).map((dto) => {
    const index = new InternalAuditScopeIndex();
    index.internalAuditId = dto.internalAuditId;
    index.items = mapFromInternalAuditScopeItems(dto.items);

    return index;
  });
}

export function mapFromInternalAuditScope(dto: InternalAuditScopeDTO): InternalAuditScope {
  const scope = new InternalAuditScope();
  scope.internalAuditId = dto.internalAuditId;

  scope.items = (dto.items ?? []).map((dtoItem) => {
    const item = new InternalAuditScopeItem(
      dtoItem.entityId,
      dtoItem.entityType as EntityTypes,
      dtoItem.name ?? '',
      dtoItem.code,
    );
    item.plannedOn = fromApiDateTimeOptional(dtoItem.plannedOn);

    return item;
  });

  scope.relations = (dto.relations ?? []).map((item) => {
    const relation = new InternalAuditScopeRelation();
    relation.fromEntityType = item.fromEntityType as EntityTypes;
    relation.fromEntityId = item.fromEntityId;
    relation.toEntityType = item.toEntityType as EntityTypes;
    relation.toEntityId = item.toEntityId;

    return relation;
  });

  return scope;
}

export function mapFromInternalAuditScopeCandidates(
  dtos: InternalAuditScopeCandidateDTO[],
): InternalAuditScopeCandidate[] {
  return (dtos ?? []).map((dto) => {
    const candidate = new InternalAuditScopeCandidate();
    candidate.entity = new Entity(dto.entityId, dto.entityType as EntityTypes, dto.name ?? '', dto.code);
    candidate.isoNormIds = dto.isoNormIds ?? [];
    candidate.normIds = dto.normIds ?? [];
    candidate.score = dto.score;
    candidate.lastAuditedOn = fromApiDateTimeOptional(dto.lastAuditedOn);
    candidate.riskScore = dto.riskScore;
    candidate.riskCount = dto.riskCount;

    return candidate;
  });
}
